import { chipClasses } from "@mui/material/Chip";
import { XCircleIcon } from "@phosphor-icons/react/dist/ssr/XCircle";
import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiChip = {
	defaultProps: {
		color: "secondary", // default will be removed in material v6
		deleteIcon: <XCircleIcon />,
	},
	styleOverrides: {
		root: ({ theme }) => ({
			borderRadius: "999px",
			fontWeight: 500,
			paddingLeft: theme.spacing(1),
			paddingRight: theme.spacing(1),
			paddingTop: theme.spacing(0.75),
			paddingBottom: theme.spacing(0.75),
		}),
		outlinedSecondary: ({ theme }) => {
			// Custom case for secondary, the rest is handled by the theme

			if (theme.palette.mode === "dark") {
				return {
					borderColor: "var(--mui-palette-secondary-700)",
					color: "var(--mui-palette-secondary-50)",
				};
			}

			return {
				borderColor: "var(--mui-palette-secondary-200)",
				color: "var(--mui-palette-secondary-900)",
			};
		},
		iconSmall: { fontSize: "var(--icon-fontSize-sm)" },
		iconMedium: { fontSize: "var(--icon-fontSize-md)" },
	},
	variants: [
		{
			props: { variant: "light" as const, color: "primary" as const },
			style: {
				backgroundColor: "var(--mui-palette-primary-light)",
				color: "var(--mui-palette-primary-900)",
				border: "none",
				[`& .${chipClasses.deleteIcon}`]: {
					color: "var(--mui-palette-primary-main)",
				},
			},
		},
		{
			props: { variant: "light" as const, color: "secondary" as const },
			style: {
				backgroundColor: "var(--mui-palette-secondary-light)",
				color: "var(--mui-palette-secondary-900)",
				border: "none",
				[`& .${chipClasses.deleteIcon}`]: {
					color: "var(--mui-palette-secondary-main)",
				},
			},
		},
		{
			props: { variant: "light" as const, color: "success" as const },
			style: {
				backgroundColor: "var(--mui-palette-success-light)",
				color: "var(--mui-palette-success-900)",
				border: "none",
				[`& .${chipClasses.deleteIcon}`]: {
					color: "var(--mui-palette-success-main)",
				},
			},
		},
		{
			props: { variant: "light" as const, color: "info" as const },
			style: {
				backgroundColor: "var(--mui-palette-info-light)",
				color: "var(--mui-palette-info-900)",
				border: "none",
				[`& .${chipClasses.deleteIcon}`]: {
					color: "var(--mui-palette-info-main)",
				},
			},
		},
		{
			props: { variant: "light" as const, color: "warning" as const },
			style: {
				backgroundColor: "var(--mui-palette-warning-light)",
				color: "var(--mui-palette-warning-900)",
				border: "none",
				[`& .${chipClasses.deleteIcon}`]: {
					color: "var(--mui-palette-warning-main)",
				},
			},
		},
		{
			props: { variant: "light" as const, color: "error" as const },
			style: {
				backgroundColor: "var(--mui-palette-error-light)",
				color: "var(--mui-palette-error-900)",
				border: "none",
				[`& .${chipClasses.deleteIcon}`]: {
					color: "var(--mui-palette-error-main)",
				},
			},
		},
	],
} satisfies Components<Theme>["MuiChip"];
